const labels = {
 STOCK:'Em estoque', ACTIVE:'Ativo / em uso', INSTALLED:'Instalado', DISCARDED:'Baixa / descarte', MAINTENANCE:'Em manutenção', EXTERNAL_REPAIR:'Manutenção externa',
 OPENED:'Aberto', TRIAGE:'Triagem', ASSIGNED:'Atribuído', IN_PROGRESS:'Em andamento', WAITING:'Aguardando', RESOLVED:'Resolvido', CLOSED:'Encerrado', COMPLETED:'Concluído', CANCELED:'Cancelado',
 OPEN:'Na empresa', RETURNED:'Retornado', LOW:'Baixa', NORMAL:'Normal', HIGH:'Alta', URGENT:'Urgente',
 INPUT:'Entrada', OUTPUT:'Saída', TRANSFER:'Transferência', INSTALLATION:'Instalação', ADJUSTMENT:'Ajuste / inventário', EXTERNAL_SEND:'Envio externo',
 SUPPLY:'Material de consumo', COMPONENT:'Peça / bem reutilizável', ADMIN:'Administrador',TECHNICAL_ADMIN:'Administrador técnico',  TECHNICAL:'Técnico',VIEWER:'Somente relatórios',SYSTEM_EXTERNAL:'Sistema Externo',
 CREATE:'Cadastro',UPDATE:'Alteração',DELETE:'Baixa / exclusão',
 INSUFFICIENT:'Histórico insuficiente',LIMITED:'Histórico limitado',ESTABLISHED:'Histórico mais amplo',
};
function formatReportValue(value,type='text') {
 if(value===undefined||value===null||value==='')return 'Não informado';
 if(type==='boolean')return value===true||value==='true'?'Sim':'Não';
 if(type==='enum')return labels[String(value)] || String(value);
 if(type==='number'){const n=Number(value);return Number.isFinite(n)?n.toLocaleString('pt-BR',{maximumFractionDigits:3}):'Não informado';}
 if(type==='date'||type==='datetime'){
  const s=String(value);const match=s.match(/^(\d{4})-(\d{2})-(\d{2})/);if(!match)return s;
  return `${match[3]}/${match[2]}/${match[1]}${type==='datetime'&&s.length>10?` ${s.slice(11,19)}`:''}`;
 }
 return String(value);
}
module.exports={formatReportValue,reportEnumLabels:labels};
